import {
  AlertDialog,
  AlertDialogBody,
  AlertDialogContent,
  AlertDialogFooter,
  AlertDialogHeader,
  AlertDialogOverlay,
  AlertDialogProps,
  Button,
  Divider,
  HStack,
} from '@chakra-ui/react';
import { useTranslations } from 'use-intl';

type Props = {
  onDelete: () => void;
  onClose: () => void;
  title?: string;
  subtitle?: string;
  leastDestructiveRef: AlertDialogProps['leastDestructiveRef'];
} & Omit<AlertDialogProps, 'onClose' | 'children' | 'leastDestructiveRef'>;

export function DeleteDraftConfirmModal({
  onDelete,
  onClose,
  title,
  subtitle,
  ...props
}: Props): JSX.Element {
  const i18nGeneral = useTranslations('General');
  const i18nDeleteDraftConfirmModal = useTranslations('DeleteDraftConfirmModal');

  return (
    <AlertDialog onClose={onClose} {...props}>
      <AlertDialogOverlay>
        <AlertDialogContent>
          <AlertDialogHeader fontSize="xl" fontWeight="500">
            {title || i18nDeleteDraftConfirmModal('Title')}
          </AlertDialogHeader>
          <AlertDialogBody>{subtitle || i18nDeleteDraftConfirmModal('SubTitle')}</AlertDialogBody>
          <Divider />
          <AlertDialogFooter as={HStack} spacing="4">
            <Button variant="secondary" onClick={onClose}>
              {i18nGeneral('Cancel')}
            </Button>
            <Button variant="delete" onClick={onDelete}>
              {i18nGeneral('Delete')}
            </Button>
          </AlertDialogFooter>
        </AlertDialogContent>
      </AlertDialogOverlay>
    </AlertDialog>
  );
}

export type DeleteDraftConfirmModal = Props;
